import React from 'react'
import ContractorVerification from "./ContractorVerification";

function Index(
    {
        expanded
    }) {
    return (expanded && <ContractorVerification />)
}


export default Index;